export const BASE_LIGHT_THEME_PALETTE = {
    themeDarker: '#004578', // 40
    themeDark: '#005A9E', // 60
    themeDarkAlt: '#106EBE', // 70
    themePrimary: '#0078d4', // 80
    themeSecondary: '#2B88D8', // 100-ish
    themeTertiary: '#71AFE5', // Between 120 and 130
    themeLight: '#C7E0F4', // 140
    themeLighter: '#DEECF9', // 150
    themeLighterAlt: '#EFF6FC', // 160
    headerBackground: '#0078d4',
    headerBackgroundSearch: '#005A9E',
    headerBrandText: '#FFFFFF',
    headerTextIcons: '#FFFFFF',
    headerSearchBoxBackground: 'rgba(255,255,255,.7)',
    headerSearchBoxIcon: '#004578',
    headerSearchPlaceholderText: '#004578',
    headerSearchButtonBackground: '#0078d4',
    headerSearchButtonBackgroundHover: '#004578',
    headerSearchButtonIcon: '#FFFFFF',
    headerSearchFilters: '#0078d4',
    headerSearchFiltersHover: '#004578',
    headerButtonsBackground: '#0078d4',
    headerButtonsBackgroundHover: '#005A9E',
    headerButtonsBackgroundSearch: '#005A9E',
    headerButtonsBackgroundSearchHover: '#004578',
    headerBadgeBackground: '#004578',
    headerBadgeText: '#FFFFFF',
    headerSearchIcon: '#FFFFFF',
    searchBoxBackground: 'rgba(255,255,255,.7)',

    black: '#000000',
    blackTranslucent50: 'rgba(0,0,0,.5)',
    blackTranslucent40: 'rgba(0,0,0,.4)',
    blackTranslucent10: 'rgba(0,0,0,.1)',
    white: '#ffffff',
    whiteTranslucent40: 'rgba(255,255,255,.4)',
    whiteTranslucent90: 'rgba(255,255,255,.9)',
    neutralDark: '#201f1e',
    neutralPrimary: '#323130',
    neutralPrimaryAlt: '#3b3a39',
    neutralSecondary: '#605e5c',
    neutralTertiary: '#a19f9d',
    neutralTertiaryAlt: '#c8c6c4',
    neutralQuaternary: '#d2d0ce',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralLight: '#edebe9',
    neutralLighter: '#f3f2f1',
    neutralLighterAlt: '#faf9f8',
    redDark: '#a4262c',
    green20: '#0b6a0b',
    purple: '#5c2d91',

    flaggedMessage: '#fffdd9',
    richUserContentBackground: '#fff',
    composeNeutralBackground: '#fff',
    composeNeutralLighterBackground: '#f4f4f4',
    readingPaneCardBorder: '#edebe9',
    readingPaneCardFocusBorder: '#d0d0d0',
};
